<template>
  <b-card>
    <certifications-terms-edit-form
      :certification-data="certificationData"
      :loading="loading"
      :send-information-email.sync="sendInformationEmail"
      @submit="submit"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import certificationDefaultDescription from '@/helpers/certificationDefaultDescription'
import {
  createCertificationSlotInput,
  DEFAULT_CERTIFICATION_SLOT_TIME,
} from '@/helpers/certification/certificationTermsFormLogic'
import buildCertificationPayload from '@/helpers/buildCertificationPayload'
import resolveCertificationTermsApiError from '@/helpers/certification/resolveCertificationTermsApiError'
import CertificationsTermsEditForm from './CertificationsTermsEditForm.vue'

export default {
  components: {
    BCard,
    CertificationsTermsEditForm,
  },
  data() {
    return {
      certificationData: {
        kind: null,
        description: certificationDefaultDescription,
        date: null,
        slotTimeInputs: [
          createCertificationSlotInput(DEFAULT_CERTIFICATION_SLOT_TIME),
        ],
        departments: [],
        examiner: null,
        localization: '',
        priceInGrosze: 0,
        isFree: false,
        status: 'PUBLIC',
        dealers: [],
        informationMaterials: [],
        reportMaterials: [],
        takenSlotsCount: 0,
      },
      loading: false,
      sendInformationEmail: false,
    }
  },
  methods: {
    submit() {
      const payload = buildCertificationPayload(
        this.certificationData,
        this.sendInformationEmail,
      )
      this.loading = true
      store
        .dispatch('certification/addCertification', payload)
        .then(response => {
          if (response && response.status === 201) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Dodano termin certyfikacji',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$router.push('/certifications-terms/list')
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Nie udało się utworzyć terminu certyfikacji.',
                icon: 'AlertCircleIcon',
                variant: 'danger',
                text: resolveCertificationTermsApiError(
                  response?.data?.['hydra:description'],
                ),
              },
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
